import { Controller } from "@hotwired/stimulus"

// Puts keyboard focus back on the control a write replaced. The permissions grid is re-rendered
// wholesale after every change, so the <select> the admin just used is destroyed and focus falls
// to <body> — on a screen whose whole job is making many changes in a row, that means being
// dumped to the top of the document after each one.
//
// The server names the control it just wrote; this restores focus to it on the render that
// follows. On first paint nothing was written, so the value is blank and connect() is a no-op.
//
// Scroll is deliberately not moved: the control was already on screen a moment ago, and this
// runs on every re-render.
export default class extends Controller {
  static values = { id: String }

  connect() {
    if (!this.hasIdValue || this.idValue === "") return

    document.getElementById(this.idValue)?.focus({ preventScroll: true })
  }
}
